module.exports = __webpack_public_path__ + "img/3.3c9634f3.svg";